import { useContext } from 'react';

import { capitalCase } from 'change-case';
import { Button, Col } from 'react-bootstrap';
import { MdChat } from 'react-icons/md';

import AskForHelp from '../AskForHelp';
import useCreateConversationAndRedirect from '@website/components/chat/utils/useCreateConversationAndRedirect';
import {
  createGuideNamesText,
  createMainContactsText,
} from '@website/components/me/bookings/sections/Host';
import HostAndTeamAvatar from '@website/components/me/bookings/sections/utils/HostAndTeamAvatar';
import { Store } from '@website/Store';
import { TripsPageQuery } from '@website/types/graphqlOperations';




type Props = {
  host: Pick<
    TripsPageQuery['tripByURL']['host'],
    'name' | 'id' | 'businessAddress' | 'team'
  >;
};

/**
 * Contact guide button
 *
 * Will only show if the user is signed in
 */
export function ContactGuideButton({ host }: Props) {
  // Get the user ID for starting the chat
  const { state } = useContext(Store);

  const createChannelAndRedirect = useCreateConversationAndRedirect(
    state.user.id,
    host.id,
  );

  return (
    <>
      <Button onClick={() => createChannelAndRedirect()} className="mb-2 me-2">
        <label className="my-0 me-2">
          <MdChat size="1.4em" />
        </label>
        Ask {host.team.items?.[0]?.givenName} a question
      </Button>
    </>
  );
}

export default function TripsPageHostInfo({
  tripTitle,
  host,
}: {
  tripTitle: string;
  host: Props['host'];
}) {
  // Get the main contacts text
  const mainContactsText = createMainContactsText(host.team);
  const guideNames = createGuideNamesText(host.team);

  return (
    <div className="my-5">
      <div className="d-flex flex-column flex-md-row align-items-center mb-3">
        <Col>
          <h5 className="mb-4">{mainContactsText}</h5>
          <p className="text-muted small">
            All trips on Skyhook are run by small, hand-picked local guiding
            companies. For this trip you'll be led by {guideNames}
            {host.businessAddress?.locality
              ? ` and the guiding team based in ${capitalCase(host.businessAddress?.locality)}`
              : ''}
            .
          </p>

          <p className="text-muted small mb-0">
            By booking through Skyhook you'll be joining a small-group trip.
            This can make it nice and sociable (you'll be added to a group chat
            after booking), and guarantees great value for money!
          </p>
        </Col>
        <HostAndTeamAvatar host={host} />
      </div>

      <div className="mb-4">
        <AskForHelp
          type="host-help"
          tripTitle={tripTitle}
          link={'/help/contact'}
        />
      </div>
    </div>
  );
}
